import React from "react";
import { useHistory } from "react-router-dom";
import Table from "../../Common/Table";

import TableFields from "../../../constants/State/TableFields.json";
import { getPath } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";

const StateList = (props) => {
  const history = useHistory();
  const { stateList } = props;
  const allActions = MenuActionsMappings[MenuNames.STATE];

  const getFieldValue = (state, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Permitted Actions"
          >
            <span
              onClick={() => history.push(`/states/${state.id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      default:
        return getPath(state, key, "NA");
    }
  };

  return (
    <Table
      list={stateList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default StateList;
